<template>
    <el-dialog
        class="edit-remark"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Remark"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="editForm"
                :model="editForm"
                :rules="rules"
                label-width="80px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Business" prop="business" size="small">
                            <el-input
                                size="small"
                                v-model="editForm.business"
                                placeholder="Please input business"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Code" prop="code" size="small">
                            <el-input
                                size="small"
                                v-model="editForm.code"
                                placeholder="Code"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="User Name" prop="user_id" size="small">
                            <el-select
                                v-model="editForm.user_name"
                                placeholder="Please input user"
                                filterable
                                clearable
                                :filter-method="userSelect"
                                :remote="true"
                                @change="userChange"
                            >
                                <el-option
                                    v-for="item in userList"
                                    :key="item.id"
                                    :label="item.username"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="ERP USER ID" prop="erp_user_id" size="small">
                            <el-input
                                v-model="editForm.erp_user_id"
                                placeholder="ERP USER ID"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                business: "",
                code: "",
                user_id: "",
                user_name:"",
                erp_user_id: "",
            },
            rules: {
                business: [
                    {
                        required: true,
                        message: "Please input business",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "Please input code",
                    },
                ],
            },
            userList:[],
        };
    },
    methods: {
        userChange(val){            
            this.editForm.user_id = val;
        },
        closeDialog() {
            this.editForm = {
                business: "",
                code:"",
                user_id: "",
                erp_user_id: "",
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .businessCode(
                            {
                                business: this.editForm.business,
                                code: this.editForm.code,
                                user_id: this.editForm.user_id,
                                erp_user_id: this.editForm.erp_user_id,
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        businessCode() {
            cmofferApi
                .businessCode({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.editForm = {
                            erp_user_id: res.data.erp_user_id,
                            user_id: res.data.user_id,
                            user_name: res.data.user_name,
                            code: res.data.code,
                            business: res.data.business,
                        };
                    }
                })
                .catch(() => {});
        },
        userSelect(val){
            cmofferApi.userSelect({keyword: val,role:1}, "get").then((res) => {
                if (res) {
                    this.userList = res.data;
                }
            });
        }
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        editVisible(val) {
            if (val) {
                this.businessCode();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.edit-remark {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
